/* Svensk katalog for locale-settings-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'set.acc.assetAutomaticPostingExplanation': 'Avskrivningar bokförs automatiskt för varje avslutad månad. Plumme tar igen saknade månader utan att du behöver göra något.',
  'set.acc.paymentDays': 'Standardbetalningsvillkor (dagar)',
  'set.acc.paymentDaysHelp': 'Förfallodatum följer fakturadatum med detta villkor. Du kan åsidosätta förfallodatum på den enskilda fakturan.',
  'set.acc.paymentDaysInvalid': 'Välj ett betalningsvillkor från 0 till 365 hela dagar.',
  'set.acc.foreignCurrencyInvoices': 'Fakturor i utländsk valuta',
  'set.acc.foreignCurrencyInvoicesHelp': 'Visa dokumentvaluta och kursfält i Ny försäljning. Låt detta vara avstängt om du bara fakturerar i redovisningsvalutan.',
  'set.acc.advancedVatDeduction': 'Avancerat momsavdrag på inköpsrader',
  'set.acc.advancedVatDeductionHelp': 'Visa val för helt eller delvis avdrag när dokumentet har moms. Valet är normalt 100 %, och befintliga avvikelser visas alltid.',
  'set.acc.openingAssets': 'Anläggningstillgångar i ingående balans',
  'set.acc.openingAssetsHelp': 'Registrera detaljerna för tillgångar som redan ingår i den ingående balansen. Beloppen stäms av mot den ingående balansen, men tillgångarna förs i anläggningsregistret.',
  'set.acc.openingAssetsAction': 'Registrera befintlig anläggningstillgång',
  'set.acc.assetAutomation': 'Automatisk månadsbokföring av avskrivningar',
  'set.acc.assetAutomationHelp': 'Kontrollera belopp och period innan du bekräftar. Aktivering bokför utestående avslutade månader och godkänner fortsatt automatik. Paus tar inte bort några bokförda verifikationer.',
  'set.acc.assetAutomationActive': 'Aktiv för valt räkenskapsår.',
  'set.acc.assetAutomationOff': 'Inaktiverad för valt räkenskapsår.',
  'set.acc.assetAutomationReview': 'Pausad. Kontrollera och godkänn det uppdaterade tillgångsunderlaget innan fortsatt automatisk bokföring.',
  'set.acc.assetAutomationEnableNote': 'Godkänd automatisk månatlig bokföring av redovisningsmässiga avskrivningar.',
  'set.acc.assetAutomationDisableNote': 'Automatisk månatlig bokföring stoppad av användaren.',
  'set.bank.activeFromHelp': 'Uppföljningen förväntar sig bara kontoutdrag från detta datum och framåt.',
  'set.bank.noReconciliationHelp': 'Utan bankavstämning måste du själv kontrollera att alla bankrörelser är bokförda en gång, att banksaldot stämmer med bokföringen och att privata och företagsrelaterade betalningar inte blandas.',
  'set.bank.newAccount': 'Nytt bankkonto',
  'set.bank.invoiceDeleteBlocked': 'Fakturakontot kan inte tas bort förrän ett annat konto har valts',
  'set.bank.deleteOrDisable': 'Ta bort eller inaktivera konto',
  'set.bank.openingBalanceHelp': 'Bankens saldo vid slutet av det senaste datum som redan är avstämt. Det är kontrollankare för bankavstämningen, men bokför inte ingående balans; IB förs under Bokföring med ett motkonto.',
  'set.bank.openingBalanceDateHelp': 'Plumme börjar bankavstämningen dagen efter detta datum.',
  'set.bank.setupValidation.date': "Välj ett giltigt datum.",
  'set.bank.setupValidation.year': "Datumet måste ligga i räkenskapsår {year}. Byt räkenskapsår för en annan start.",
  'set.bank.setupValidation.amount': "Ange bankens dokumenterade saldo. Ange 0 om kontot var tomt.",
  'set.bank.setupValidation.counter': "Välj motkonto från den dokumenterade ingående balansen.",
  'set.bank.setupTitle': 'Ställ in startsaldo',
  'set.bank.setupIntro': 'Registrera bankens dokumenterade saldo och den balanserade bokföringen i ett flöde. Plumme gissar aldrig motkonto.',
  'set.bank.setupYearStart': 'Starta vid nytt räkenskapsår',
  'set.bank.setupYearStartHelp': 'Använd saldot vid slutet av föregående år som bankens IB för det nya året.',
  'set.bank.setupMidYear': 'Flytta till Plumme mitt i året',
  'set.bank.setupMidYearHelp': 'Använd saldot dagen innan Plumme tar över bokföringen.',
  'set.bank.setupNewAccount': 'Nytt bankkonto i en löpande bokföring',
  'set.bank.setupNewAccountHelp': 'En överföring till ett nytt konto är en vanlig transaktion, inte ingående balans.',
  'set.bank.setupUnsupported': 'Samlat startsaldo för bank och bokföring stöds än så länge bara för norska NOK-konton. Använd de separata bokförings- och bankflödena för detta konto.',
  'set.bank.setupNewAccountTitle': 'Bokför den faktiska överföringen',
  'set.bank.setupNewAccountBody': 'Skapa eller importera transaktionen som flyttade pengarna till kontot. När huvudboken stämmer med banken kan bankavstämningen starta utan en ny ingående balans.',
  'set.bank.setupTransitionDate': 'Första dagen i Plumme',
  'set.bank.setupTransitionYearHint': "F\u00f6rsta dagen i valt r\u00e4kenskaps\u00e5r. ({year})",
  'set.bank.setupTransitionMidYearHint': 'Datumet då Plumme tar över från det tidigare systemet.',
  'set.bank.setupEvidenceDate': 'Bankens saldo per',
  'set.bank.setupEvidenceDateHint': 'Beräknas som dagen innan Plumme tar över.',
  'set.bank.setupBankBalance': 'Bankens dokumenterade saldo',
  'set.bank.setupBankBalanceHint': 'Använd saldot från kontoutdraget på brytdatumet.',
  'set.bank.setupLedgerAccount': 'Bankkonto i huvudboken',
  'set.bank.setupCounterAccount': 'Motkonto i ingående balans',
  'set.bank.setupCounterHelp': 'Välj var bankbeloppet kommer ifrån. Detta kan inte avgöras av banksaldot ensamt.',
  'set.bank.setupChooseCounter': 'Välj motkonto',
  'set.bank.setupNoCounter': 'Inget motkonto behövs vid nollsaldo',
  'set.bank.setupNoCounterMatches': 'Inga balanskonton matchar sökningen.',
  'set.bank.setupManagedInBank': 'Kopplat till startsaldot under Inställningar - Bank',
  'set.bank.setupMidYearWarning': 'Banksaldot är bara en del av övergången. Lägg också in eller importera övriga balans-, resultat- och momssiffror från tidigare system under Bokföring.',
  'set.bank.setupPreview': 'Detta sparas samlat',
  'set.bank.setupPreviewText': 'Bankbevis: {amount} per brytdatum. Bokförings-IB: {bank} mot {counter}.',
  'set.bank.setupNotChosen': 'motkonto inte valt',
  'set.bank.setupSave': 'Spara startsaldo och IB',
  'set.bank.setupSaveError': 'Det gick inte att spara startsaldot.',
  'set.bank.setupPostingNote': 'Bankens startsaldo – {account}',
  'set.bank.setupButton': 'Ställ in eller korrigera startsaldo',
  'set.bank.setupSummaryTitle': 'Bankens saldo vid start',
  'set.bank.setupSummaryEmpty': 'Startsaldo och bokförings-IB är inte inställda.',
  'set.bank.setupSummaryValue': '{amount} per {date}',
  'set.bank.setupSaved': 'Startsaldo och ingående balans har sparats',
  'set.bank.setupSaveAccountFirst': 'Spara bankkontot först. Därefter kan startsaldo och ingående balans ställas in samlat.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'Visa IBAN och BIC på fakturan',
  'set.role.owner': 'Ägare',
  'set.access.noOrgNumber': 'Utan org.nr',
  'set.access.onboardingUnavailable': 'Onboarding är inte laddad.',
  'set.access.members': 'Medlemmar',
  'set.access.membersSub': 'Ägare och administratörer kan ta bort aktiva åtkomster. Ägarskapet måste överföras innan ägarens egen åtkomst kan tas bort.',
  'set.access.membersOnlyAdmin': 'Bara ägare och administratörer kan hantera medlemmar.',
  'set.access.selfRemoveHelp': 'Du kan ändå ta bort din egen åtkomst om du inte är ägare.',
  'set.access.you': 'du',
  'set.access.remove': 'Ta bort',
  'set.access.membersEmpty': 'Aktiva medlemmar visas för ägare och administratörer.',
  'set.access.removeSelf': 'Ta bort min åtkomst',
  'set.access.transferTitle': 'Överför ägarskap',
  'set.access.transferSub': 'Skicka en kontrollerad inbjudan till den nya ägaren. Ägarskapet flyttas först när mottagaren loggar in och godkänner.',
  'set.access.transferOnlyOwner': 'Bara ägaren kan överföra ägarskap.',
  'set.access.transferAdminHelp': 'Administratörer kan bjuda in samarbetspartner men kan inte byta ägare.',
  'set.access.newOwnerEmail': 'Ny ägares e-postadress',
  'set.access.afterTransferRole': 'Din åtkomst efter överlåtelsen',
  'set.access.roleAdministrator': 'Administratör',
  'set.access.transferReason': 'Orsak / anteckning för granskningslogg',
  'set.access.transferReasonPlaceholder': 'T.ex. sålt företaget eller skapat åt en kund',
  'set.access.sendTransfer': 'Skicka ägarbyte',
  'set.access.ownershipTransfer': 'Ägarbyte',
  'set.access.expired': 'Utgången',
  'set.access.viewAccept': 'Visa och godkänn',
  'set.access.unknown': 'okänd',
  'set.access.resend': 'Skicka igen',
  'set.tab.accounting': 'Bokföring',
  'set.tab.data': 'Data',
  'set.companyEmailHint': 'Hämtas från din inloggning.',
  'set.countryLocked': 'Land väljs när företaget skapas och kan inte ändras här. Kontakta support vid fel.',
  'set.inboxUpdatedAt': 'Senast uppdaterad {date}',
  'set.inboxCopied': 'E-post kopierad',
  'set.profileEmailHint': 'E-post ändras inte här, eftersom Firebase kan kräva ny inloggning.',
  'set.subscriptionPlan': 'Plan: {plan}',
  'set.subscriptionInactive': 'Abonnemanget är inte aktiverat',
  'set.subscriptionTrialUntil': 'Provperiod till {date}',
  'set.subscriptionChooseHelp': 'Välj plan för att starta checkout i Stripe.',
  'set.subscriptionDisconnected': 'Inte ansluten',
  'set.subscriptionCurrentPlan': 'Nuvarande plan',
  'set.subscriptionChoosePlan': 'Välj {name}',
  'set.subscriptionFeature.bookkeeping': 'Bokföring',
  'set.subscriptionFeature.invoiceEmailEhf': 'Faktura via e-post och EHF',
  'set.subscriptionFeature.publicFiling': 'Inlämning till myndigheter',
  'set.subscriptionFeature.invoiceEmail': 'Faktura via e-post',
  'set.subscriptionFeature.taxFigures': 'Siffror för moms och skattemelding',
  'set.subscriptionFeature.taxIntegration': 'Integration mot Skatteetaten',
  'set.acc.setupTab': 'Inställningar',
  'set.acc.chartTab': 'Kontoplan',
  'set.acc.vatPeriodAnnual': 'Årlig',
  'set.acc.vatPeriodBimonthly': 'Varannan mån',
  'set.acc.vatPeriodMonthly': 'Månatlig',
  'set.acc.vatPeriodQuarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.monthly': 'Månatlig',
  'set.acc.vatPeriod.bimonthly': 'Varannan månad',
  'set.acc.vatPeriod.quarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.semiannual': 'Halvårsvis',
  'set.acc.vatPeriod.annual': 'Årlig',
  'set.acc.vatPeriodEffectiveYear': 'Gäller från år',
  'set.acc.vatPeriodEffectiveYearHelp': 'Ange året som står i beslutet från Skatteetaten. Ändringen gäller från 1 januari det året. Ett avslutat år måste öppnas igen, och inlämnade MVA-meldinger måste öppnas eller återföras först.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Ange ett giltigt år med fyra siffror.',
  'set.acc.vatPeriodHistory': 'Historik för momsperiod',
  'set.acc.vatPeriodConfirmTitle': 'Är du säker på att momsperioden ska ändras?',
  'set.acc.vatPeriodConfirmText': 'Ändringen gäller från 1 januari {year}. Kontrollera att året stämmer med beslutet från Skatteetaten. Tidigare år behålls oförändrade. Ett avslutat år måste öppnas igen, och inlämnade MVA-meldinger måste öppnas eller återföras först.',
  'set.acc.vatPeriodConfirm': 'Bekräfta ändring',
  'set.acc.notVatRegisteredNotice': 'När företaget inte är momsregistrerat sätts nya fakturor till 0 % moms. Inköp kan fortfarande registreras med moms på verifikationen, men utan avdragsrätt.',
  'set.acc.midYearText': 'Använd detta om du flyttar till Plumme mitt i året och vill att rapporterna ska fortsätta med siffror från det tidigare systemet.',
  'set.acc.openingSaved': 'Startsiffror sparade',
  'set.acc.openingSavedFrom': 'Startsiffror sparade från {date}.',
  'set.acc.openingBalanceText': 'Använd detta om du börjar vid ett nytt räkenskapsår och vill lägga in ingående balanser från föregående år.',
  'set.startup.linkedBalanceTitle': 'Ingående balans följer med',
  'set.startup.linkedBalanceHelp': 'Det här är samma balansrader som i guiden för ingående balans. Bankrader korrigeras under Inställningar - Bank.',
  'set.acc.balanceBooked': 'Bokförd {date} - {count} {lines}',
  'set.acc.line': 'rad',
  'set.acc.lines': 'rader',
  'set.acc.enterAccountNumber': 'Ange kontonummer',
  'set.acc.equivalentHint': 'Styr hanteringen i bokslut och skattemelding.',
  'set.acc.saveChart': 'Spara kontoplan',
  'set.acc.equivalentShort': 'Motsvarar',
  'set.acc.usedInHistory': 'Används i historik',
  'set.acc.activate': 'Aktivera',
  'set.acc.editAccount': 'Redigera konto',
  'set.acc.deactivateUsed': 'Inaktivera använt konto',
  'set.acc.deleteUnused': 'Ta bort oanvänt konto',
  'set.ib.intro': 'Här lägger du in ingående balanser från föregående räkenskapsår. Använd detta när du börjar vid ett nytt år och vill att balansen ska stämma från dag ett i Plumme.',
  'set.ib.attachment': 'Bilaga',
  'set.ib.uploadDocuments': 'Ladda upp dokument',
  'set.ib.uploading': 'Laddar upp...',
  'set.ib.created': 'Skapad',
  'set.ib.uploadReceipt': 'Ladda upp ny verifikation',
  'set.ib.emptyHelp': 'Du måste lägga till minst en rad innan du kan skapa ingående balans. Använd knappen "Lägg till ny rad" för att lägga in siffrorna från det tidigare systemet.',
  'set.ib.postHelp': 'Bekräfta att den ingående balansen är korrekt och klar att bokföras. Du kan fortfarande ändra den efteråt så länge perioden är öppen.',
  'set.ib.draftFor': 'Utkast till ingående balans för {date}',
  'set.ib.createdAt': 'Skapad {date}',
  'set.ib.balanceHelp': 'Ange saldot för varje konto från den avslutade bokföringen. Hela den ingående balansen måste ha lika stor summa debet och kredit.',
  'set.ib.noteOptional': 'Anmärkning (valfritt)',
  'set.ib.difference': 'Differens',
  'set.ib.saveDraft': 'Spara utkast',
  'set.ib.validationHelp': 'Kontrollera att varje rad har konto och ett positivt belopp på endast en sida, och att summa debet är lika med summa kredit.',
  'set.ib.excludedRows': '{count} resultat- eller okända konton hålls utanför ordinarie IB. Kontrollera dem i importunderlaget.',
  'set.transitionImport.confirmSigned': 'Bekräfta kolumn och tecken före import',
  'set.transitionImport.balanceColumn': 'Saldokolumn',
  'set.transitionImport.signConvention': 'Teckenkonvention',
  'set.transitionImport.positiveDebit': 'Positivt är debet, negativt är kredit',
  'set.transitionImport.positiveCredit': 'Positivt är kredit, negativt är debet',
  'set.transitionImport.signExample': 'Exempel: Med ”positivt är debet” blir −427 473,92 kredit 427 473,92.',
  'set.transitionImport.confirmImport': 'Bekräfta och förhandsgranska',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV eller bild. Dra in eller klistra in med Ctrl+V.',
  'sd.deleteAllTitle': 'Ta bort alla {label}',
  'sd.deleteAllMessage': 'Ta bort alla {label} ({count})? Historiska fakturor och verifikationer behålls, men registret töms. Detta kan inte ångras. Vi rekommenderar att du gör en export först.',
  'sd.label.customers': 'kunder',
  'sd.label.suppliers': 'leverantörer',
  'sd.label.products': 'produkter',
  'sd.importing': 'Importerar...',
  'sd.documentReferenceMissing': 'Dokumentet saknar referens till importpaketet.',
  'sd.documentLinkFailed': 'Kunde inte hämta dokumentlänken.',
  'sd.documentOpenFailed': 'Kunde inte öppna importdokumentet.',
  'sd.kind.voucher': 'Verifikation',
  'sd.kind.inbox': 'Inkorg',
  'sd.kind.bankReconciliation': 'Bankavstämningar',
  'sd.kind.company': 'Företagsdokument',
  'sd.kind.invoice': 'Faktura',
  'sd.kind.quote': 'Offert',
  'sd.kind.creditNote': 'Kreditfaktura',
  'sd.kind.orderConfirmation': 'Orderbekräftelse',
  'sd.kind.paymentReminder': 'Betalningspåminnelse',
  'sd.kind.otherCount': 'Övriga {count}',
  'sd.kind.allCount': 'Alla {count}',
  'sd.reportCsv': 'Rapport CSV',
  'sd.reportXlsx': 'Rapport XLSX',
  'sd.openItems.exported': '{count} öppna poster exporterade',
  'sd.openItems.exportFailed': 'Kunde inte exportera rapporten.',
  'sd.openItems.title': 'Kontrollera importerade öppna poster',
  'sd.openItems.count': 'öppna poster',
  'sd.openItems.remainingTotal': 'summa restbelopp',
  'sd.openItems.possibleDeviations': 'möjliga avvikelser',
  'sd.openItems.search': 'Sök på namn, fakturanr, datum eller blad',
  'sd.filter.all': 'Alla',
  'sd.filter.customers': 'Kunder',
  'sd.filter.suppliers': 'Leverantörer',
  'sd.openItems.checkDeviation': 'Kontrollera avvikelser mot reskontrasaldo',
  'sd.openItems.deviation': '{label}: {party} avviker med {amount}',
  'sd.unnamed': 'Namnlös',
  'sd.openItems.rowMeta': '#{invoice} · datum {date} · förfaller {due}',
  'sd.openItems.empty': 'Inga öppna importposter matchar filtret.',
  'sd.documents.title': 'Importerat dokumentarkiv',
  'sd.documents.count': 'dokument',
  'sd.documents.types': 'typer',
  'sd.documents.packages': 'exportpaket',
  'sd.documents.search': 'Sök på fil, år, verifikationsnr eller intern sökväg',
  'sd.documents.sortType': 'Sortera: typ',
  'sd.documents.sortYear': 'Sortera: år',
  'sd.documents.sortName': 'Sortera: filnamn',
  'sd.documents.basis': 'Arkivunderlag',
  'sd.documents.basisHelp': 'Dokumenten är lagrade som importindex mot det ursprungliga exportpaketet. De skapar inte fakturor, inköp, verifikationer eller inkorgsobjekt automatiskt.',
  'sd.documents.fallback': 'Dokument',
  'sd.documents.unknownPath': 'Okänd sökväg i exportpaketet',
  'sd.documents.fetching': 'Hämtar...',
  'sd.documents.open': 'Öppna',
  'sd.documents.empty': 'Inga importerade dokument matchar filtret.',
  'sd.ledger.title': 'Importerat huvudboksarkiv',
  'sd.ledger.linesShown': 'historikrader i visat arkiv',
  'sd.ledger.debitShown': 'debet i visat urval',
  'sd.ledger.creditShown': 'kredit i visat urval',
  'sd.ledger.search': 'Sök på verifikation, konto, text, datum eller källa',
  'sd.ledger.allYears': 'Alla år',
  'sd.ledger.historyOnly': 'Endast historik',
  'sd.ledger.historyHelp': 'Raderna här är ett läsbart importarkiv från tidigare system. Summorna ovan är debet/kredit för visat arkivurval, inte omsättning. Raderna ingår inte i Plumme-rapporter, moms, skatt, bankavstämning eller den aktiva verifikationslistan.',
  'sd.ledger.noText': 'Ingen text',
  'sd.ledger.linkedCount': '{count} kopplade verifikationer i dokumentarkivet',
  'sd.ledger.empty': 'Inga importerade huvudboksrader matchar filtret.',
  'sd.ledger.linkedTitle': 'Kopplade verifikationer',
  'sd.ledger.archiveDocument': 'Arkivdokument',
  'sd.ledger.archiveDocumentHelp': 'Det här är dokumentreferenser från det ursprungliga exportpaketet. De skapar inte aktiva verifikationer eller poster i inkorgen.',
  'sd.ledger.noDocumentDetails': 'Inga dokumentdetaljer sparade för den här raden.',
  'sd.ledger.showing': 'Visar {shown} av {total} träffar för den här historikraden.',
  'sd.transition.exported': '{count} år exporterade',
  'sd.transition.exportFailed': 'Kunde inte exportera övergångsrapporten.',
  'sd.transition.title': 'Avstämning och övergångsrapport',
  'sd.transition.years': 'år',
  'sd.transition.openingLines': 'IB-rader',
  'sd.transition.historyLines': 'historikrader',
  'sd.transition.warnings': 'kontrollvarningar',
  'sd.transition.control': 'Övergångskontroll',
  'sd.transition.controlHelp': 'Rapporten sammanställer importerad ingående balans, reskontra, bank och huvudbokshistorik per år. Siffrorna är kontrollunderlag och bokförs inte automatiskt.',
  'sd.transition.latestSubledger': 'Importerat reskontrasaldo utan eget år visas på {year} som senast importerade reskontra.',
  'sd.transition.rowSummary': '{opening} IB-rader · {accounts} historiska kontosaldon · {history} historikrader · bank IB {bank}',
  'sd.transition.warningCount': '{count} varningar',
  'sd.transition.discrepancy': 'Avvikelse {amount}',
  'sd.transition.historicalBalance': 'Historiskt saldo',
  'sd.transition.balanceSequence': 'IB / förändring / UB',
  'sd.transition.historicalResult': 'Historiskt resultat',
  'sd.transition.incomeCost': 'Intäkt {income} · kostnad {cost}',
  'sd.transition.itemsDeviation': '{count} poster · avvikelse {amount}',
  'sd.transition.supplierSubledger': 'Leverantörsreskontra',
  'sd.transition.ledgerArchive': 'Huvudboksarkiv',
  'sd.transition.empty': 'Inga importerade övergångssiffror att visa ännu.',
  'sd.vatTax.exported': '{count} rader exporterade',
  'sd.vatTax.exportFailed': 'Kunde inte exportera moms-/skattehistoriken.',
  'sd.vatTax.title': 'Moms och skatt från importhistorik',
  'sd.vatTax.periods': 'Momsperioder',
  'sd.vatTax.netVat': 'nettomoms',
  'sd.vatTax.resultBeforeTax': 'resultat före skatt',
  'sd.vatTax.basis': 'Historiskt kontrollunderlag',
  'sd.vatTax.basisHelp': 'Momsen summeras från importerade 270x/271x-konton per period. SAF-T-momskoder visas som kodunderlag där exportfilen innehåller dem. Detta skapar inte nya MVA-meldinger, verifikationer eller skattekonteringar.',
  'sd.vatTax.yearSummary': '{count} perioder · resultat före skatt {amount}',
  'sd.vatTax.archive': 'Arkiv',
  'sd.vatTax.period': 'Period {number} · {label}',
  'sd.vatTax.outputInput': 'Utg. {output} · ing. {input}',
  'sd.vatTax.empty': 'Ingen importerad moms-/skattehistorik att visa ännu.',
  'sd.vatTax.codes': 'SAF-T-momskoder',
  'sd.vatTax.showing': 'Visar {shown} av {total}',
  'sd.vatTax.code': '{year}-{month} kod {code}',
  'sd.vatTax.baseVat': 'Underlag {base} · moms {vat} · {rate}%',
  'sd.resetMessage': 'Detta raderar permanent alla bokförings- och driftsdata i valt företag: fakturor, verifikationer, betalningar, kunder, leverantörer, produkter, lön, bankdata, ingående balans, importarkiv, filer och alla löpnummer. Åtgärden kan inte ångras. Gör en fullständig export först om något ska behållas.',
  'sd.resetPreserved': 'Själva företagsprofilen, medlemmar, abonnemang och integrationskopplingar behålls. Använd «Ta bort företag» om även detta ska tas bort.',
  'sd.resetPhrase': 'BEKRÄFTA',
  'sd.resetTypeLabel': 'Skriv {phrase} för att aktivera nollställning',
  'sd.resetTypeHint': 'Knappen förblir inaktiverad tills texten har skrivits exakt.',
  'sd.resetConfirm': 'Ta bort och nollställ allt',
  'sd.resetComplete': 'Alla bokförings- och driftsdata har raderats. Företaget är nollställt.',
  'sd.resetFailed': 'Kunde inte slutföra nollställningen.',
  'sd.deleteBusinessMessage': 'Vill du planera borttagning av valt företag om 30 dagar? Företaget, data och åtkomst tas bort efter karenstiden. Du kan avbryta borttagningen före tidsfristen.',
  'sd.deleteBusinessConfirm': 'Planera borttagning',
  'sd.customersTitle': 'Import / Export av kunder',
  'sd.suppliersTitle': 'Import / Export av leverantörer',
  'sd.productsTitle': 'Import / Export av produkter',
  'sd.invoicesTitle': 'Import / Export av fakturor',
  'sd.vouchersTitle': 'Import / Export av verifikationer',
  'sd.supportedFormats': 'Importformat som stöds: .xlsx och .csv.',
  'sd.productsHelp': 'Importera och exportera produkter med mallkolumner. Importformat som stöds: .xlsx och .csv.',
  'sd.invoicesHelp': 'Exportera fakturor som CSV eller importera nya fakturor med mall.',
  'sd.vouchersHelp': 'Exportera verifikationsöversikt eller bokföringsrader. Import analyseras säkert som ett komplett exportpaket.',
  'sd.importInvoices': 'Importera fakturor',
  'sd.buildingExport': 'Skapar exportpaket...',
  'sd.exportAll': 'Exportera allt (.zip)',
  'sd.technicalJson': 'Teknisk JSON',
  'sd.analyzing': 'Analyserar...',
  'sd.importOtherSystem': 'Importera från annat system',
  'sd.reviewOpenItems': 'Kontrollera öppna poster',
  'sd.documentArchive': 'Dokumentarkiv',
  'sd.ledgerArchive': 'Huvudboksarkiv',
  'sd.transitionReport': 'Övergångsrapport',
  'sd.vatTaxHistory': 'Moms-/skattehistorik',
  'sd.latestAnalysis': 'Senaste analys: {files} filer, {saft} SAF-T, {excel} Excel, {vouchers} verifikationsfiler. Status: {status}.',
  'sd.analyzed': 'analyserad',
  'sd.reanalyze': 'Analysera samma fil igen',
  'sd.reread': 'Läs in importfilen på nytt',
  'sd.rereadHelp': 'Senaste importfil är sparad, men analysen är inte klar eller har misslyckats.',
  'sd.importProposal': 'Förslag: {accounts} saldokonton, {customers} kunder, {suppliers} leverantörer, {products} produkter, {customerInvoices} öppna kundfakturor, {supplierInvoices} öppna leverantörsfakturor, {balances} ingående balanser, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} (visar {shown} av {total})',
  'sd.label.archiveDocuments': 'arkivdokument',
  'sd.label.historyLines': 'historikrader',
  'sd.saftTitle': 'Export SAF-T',
  'sd.saftHelp': 'Exportera SAF-T Financial XML (beta) eller importera kontoplan, parter och ingående balans från SAF-T XML.',
  'sd.importSaft': 'Importera SAF-T (MVP)',
});
